export enum AssessmentAssigneeType {
  Learner = 0,
  Team = 1,
  Department = 2,
  Company = 3,
}
